<template>
  <section class="bg-white">
    <div class="co-container-md mx-auto px-4 py-20">
      <div class="flex items-start justify-center">
        <img
          src="~/assets/images/YaTe/YaTeCounseling/subtitle-decoration.svg"
          alt=""
          width="14"
          height="15"
          loading="lazy"
        >
        <div class="co-display-11 ya-te-text-red mb-2 px-2 font-bold leading-normal">
          挫折させない学習サポート
        </div>
        <img
          src="~/assets/images/YaTe/YaTeCounseling/subtitle-decoration.svg"
          alt=""
          style="transform: scale(-1, 1)"
          width="14"
          height="15"
          loading="lazy"
        >
      </div>
      <h2 class="ya-te-page-title ya-te-text-primary mb-6 text-center font-extrabold">
        現役エンジニアが専属の<br class="md:hidden">パートナーに
      </h2>
      <p class="mb-12 text-center">
        Yahoo! JAPANの人材開発研修を受け、独自の採用試験に合格した現役エンジニアが<br class="hidden md:block">毎日のあなたのプログラミング学習をサポートします。
      </p>

      <div class="ya-te-bg-support relative mb-12 flex flex-col gap-3 md:flex-row md:items-center md:gap-8">
        <div class="z-10 basis-full md:basis-[16.75rem]">
          <img
            src="~/assets/images/YaTe/YaTeCounseling/MentorSupport/mentor-support-personal.svg"
            alt="専属メンターが最後まで並走"
            width="268"
            height="146"
            loading="lazy"
          >
        </div>
        <div class="z-10 basis-full md:basis-[calc(100%-268px-3rem)]">
          <h3 class="ya-te-text-primary co-display-9 mb-3 font-extrabold leading-normal">
            専属メンターが最後まで並走
          </h3>
          <p class="co-display-13">
            現役エンジニアが専属でパートナーとなり、最初から最後まで親身にサポート。<br class="hidden md:block">週2回のメンタリングでは直接質問・相談できます。学習のアドバイスだけではなく、スケジュールや進捗の相談、現場の話など何でも気軽に聞いてください。
          </p>
        </div>
      </div>
      <div class="ya-te-bg-support relative mb-12 flex flex-col gap-3 md:flex-row md:items-center md:gap-8">
        <div class="z-10 basis-full md:basis-[16.75rem]">
          <img
            src="~/assets/images/YaTe/YaTeCounseling/MentorSupport/mentor-support-chat.svg"
            alt="いつでも質問し放題"
            width="268"
            height="146"
            loading="lazy"
          >
        </div>
        <div class="z-10 basis-full md:basis-[calc(100%-268px-3rem)]">
          <h3 class="ya-te-text-primary co-display-9 mb-3 font-extrabold leading-normal">
            いつでも質問し放題
          </h3>
          <p class="co-display-13">
            自分のペースで24時間いつでも何度でも質問OK。<br class="hidden md:block">毎日専属メンターが質問をチェックして24時間以内にわかりやすく回答するので、すぐに疑問が解決します。
          </p>
        </div>
      </div>
      <div class="ya-te-bg-support relative mb-0 flex flex-col gap-3 md:mb-6 md:flex-row md:items-center md:gap-8">
        <div class="z-10 basis-full md:basis-[16.75rem]">
          <img
            src="~/assets/images/YaTe/YaTeCounseling/MentorSupport/mentor-support-review.svg"
            alt="回数無制限の課題レビュー"
            width="268"
            height="146"
            loading="lazy"
          >
        </div>
        <div class="z-10 basis-full md:basis-[calc(100%-268px-3rem)]">
          <h3 class="ya-te-text-primary co-display-9 mb-3 font-extrabold leading-normal">
            回数無制限の課題レビュー
          </h3>
          <p class="co-display-13">
            カリキュラム内の課題では、現役エンジニアのレビューを何度でも受けられます。<br class="hidden md:block">だから、学んだ技術がきちんと身につくまで課題に取り組むことができます。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
@import url("~/assets/css/YaTe/YaTeCommon/YaTeCommon.css");

/* メンターサポート */
.ya-te-bg-support {
  &::after {
    position: absolute;
    top: 1.5rem;
    left: 1.5rem;
    width: 19.9375rem;
    height: 9.125rem;
    content: '';
    background: #cdf4dd;
    @media (min-width: 768px) {
      width: 27.5rem;
    }
  }
}

/* バーチャル空間 */
.ya-te-virtual-underline {
  position: relative;
  &::before {
    position: absolute;
    bottom: -0.1875rem;
    width: 5rem;
    height: 0.1875rem;
    content: '';
    background: #f03;
  }
}
</style>
